import { Config } from '../config'
import { AppEnvs, NodeEnvs } from '../constants/global'

export const isProduction = () => Config.appEnv === AppEnvs.PRODUCTION

export const isProdByNodeEnv = () => Config.nodeEnv === NodeEnvs.PRODUCTION

export const isTestEnv = () => Config.nodeEnv === NodeEnvs.TEST

export const enableOptimizelyLogger = () =>
  !isProduction() &&
  !(Config.disableOptimizelyLogger || Config.disableAllMiddlewareLoggers)

export const enableGTMLogger = () =>
  !isProdByNodeEnv() && !(Config.disableGTMLogger || Config.disableAllMiddlewareLoggers)

export const enableReduxLogger = () =>
  !(isProdByNodeEnv() && isTestEnv()) &&
  !(Config.disableReduxLogger || Config.disableAllMiddlewareLoggers)
